import { camelize, dasherize } from '@ember/string';
import { isNone } from '@ember/utils';

import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';

import Serializer from 'umg-ember-backend/serializers/application';

let relationshipKeys = [
  'backgroundImage',
  'backgroundVideo',
  'backgroundImageMobile',
  'backgroundVideoMobile',
];

export default class ContentItemSerializer extends Serializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    entity: { embedded: 'always' },
    children: { embedded: 'always' },
  };

  normalize(_model, hash) {
    // If options are available move relations from options to model
    if (!isNone(hash.options)) {
      relationshipKeys.forEach((key) => {
        this.moveRelationship(key, hash.options, hash);
      });
    }

    // Dasherize type to match ember recordType
    hash.type = dasherize(hash.type);

    return super.normalize(...arguments);
  }

  serialize() {
    let json = super.serialize(...arguments);

    // move relations from model to options
    relationshipKeys.forEach((key) => {
      this.moveRelationship(key, json, json.options);
    });

    if (json.options.headline === '') {
      json.options.headline = null;
    }

    // Check if options are set, otherwise set to null
    let notEmpty = Object.keys(json.options).some((key) => {
      return json.options[key] !== null;
    });

    if (!notEmpty) {
      json.options = null;
    }

    // Camelize type
    json.type = camelize(json.type);

    return json;
  }
}
